<template>
  <div class="config-page" style="background: transparent !important;">
    <v-row class="pl-2">
      <v-col cols="12" lg="5" md="5" sm="12" xs="12" class="info-col">
        <v-row class="px-0">
          <Form
            v-model="selected"
            :id="selected.id"
            @closed="resetPage"
          />
        </v-row>
      </v-col>
      <v-col cols="12" lg="7" md="7" sm="12" xs="12" class="pa-0">
        <List @new="resetPage" @edit="editPage" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from './templates/Form'
import List from './templates/List'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import list from '@/mixins/defaults/list_subpage_basic'

export default {
  components: { Form, List },
  mixins: [ appdata, utils, list ],
  data () {
    return {
      pageName: 'permissions',
      default: { ...defaults.blank.permission }
    }
  },
  computed: {
    data: function () {
      return this.get_data.users_permissions || []
    }
  }
}
</script>
